import TUIChat from "./TUIChat";
import TUIConversation from "./TUIConversation";
import TUISearch from "./TUISearch";
import TUIContact from "./TUIContact";
import TUIGroup from "./TUIGroup";

const TUIComponents = {
  TUIChat,
  TUIConversation,
  TUIContact,
  TUISearch,
  TUIGroup
};

export default TUIComponents;

export {
  TUIChat,
  TUIConversation,
  TUIContact,
  TUISearch,
  TUIGroup,
};
